import React, { useEffect } from 'react';

const TeslimatVeIade = () => {
  useEffect(() => {
    document.title = 'Teslimat ve İade Koşulları - Yaşasın Hamileyim';
  }, []);

  return (
    <div style={{ 
      maxWidth: '900px', 
      margin: '0 auto', 
      padding: '40px 20px',
      lineHeight: '1.8',
      color: '#333'
    }}>
      <h1 style={{ 
        fontSize: '2rem', 
        fontWeight: '700', 
        marginBottom: '30px',
        color: '#667eea',
        textAlign: 'center'
      }}>
        TESLİMAT VE İADE KOŞULLARI
      </h1>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          1. TESLİMAT
        </h2>
        <p>
          <strong>1.1. Teslimat Yöntemi:</strong><br />
          Yaşasın Hamileyim Eğitimi dijital bir ürün olduğundan, fiziksel teslimat yapılmamaktadır. 
          Ödeme işlemi tamamlandıktan sonra, eğitim içeriğine otomatik olarak erişim sağlanır.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>1.2. Teslimat Süresi:</strong><br />
          Ödeme onayından hemen sonra, hesabınız otomatik olarak aktif hale gelir ve eğitim 
          içeriğine anında erişim sağlayabilirsiniz. Herhangi bir e-posta gönderimi yapılmaz, 
          erişim otomatik olarak sağlanır.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>1.3. Erişim:</strong><br />
          Ödeme işlemi tamamlandıktan sonra, giriş yaptığınız hesap üzerinden eğitim içeriğine 
          doğrudan erişebilirsiniz.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>1.4. Erişim Süresi:</strong><br />
          Eğitim içeriğine ömür boyu erişim hakkınız bulunmaktadır. Hesabınız aktif olduğu sürece 
          eğitim içeriğine istediğiniz zaman erişebilirsiniz.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          2. İADE KOŞULLARI
        </h2>
        <p>
          <strong>2.1. Cayma Hakkı:</strong><br />
          6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği 
          hükümlerine göre cayma hakkınız bulunmaktadır.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>2.2. Cayma Hakkı Süresi:</strong><br />
          Ödeme tarihinden itibaren 7 (yedi) gün içinde cayma hakkınızı kullanabilirsiniz.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>2.3. Cayma Hakkının Sona Ermesi:</strong><br />
          Aşağıdaki durumlardan <strong>herhangi biri</strong> gerçekleştiğinde cayma hakkı sona erer 
          ve iade yapılamaz:
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li>Ödeme tarihinden itibaren <strong>7 günün geçmesi</strong></li>
          <li>Eğitim içeriğinin <strong>%10'unun izlenmesi</strong></li>
        </ul>
        <p style={{ marginTop: '15px' }}>
          <strong>2.4. İade Süreci:</strong><br />
          Cayma hakkınızı kullanmak istediğinizde, aşağıdaki yöntemlerden biriyle bizimle iletişime 
          geçebilirsiniz:
        </p>
        <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
          <li><strong>E-posta:</strong> info@yasasinhamileyim.com</li>
          <li><strong>Telefon:</strong> 0 (532) 775 76 16</li>
        </ul>
        <p style={{ marginTop: '15px' }}>
          <strong>2.5. İade Süresi:</strong><br />
          Cayma bildiriminiz, bizimle iletişime geçtiğiniz tarihten itibaren geçerlidir. İade işlemi, 
          cayma bildiriminizin alınmasından itibaren en geç 21 iş günü içinde tamamlanır.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>2.6. İade Tutarı:</strong><br />
          İade işlemi, ödeme yaptığınız tutar üzerinden gerçekleştirilir. İade, ödeme yaptığınız 
          yönteme göre (kredi kartı, banka kartı veya havale) geri ödenir.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          3. HESAP PAYLAŞIMI VE ÜYELİK İPTALİ
        </h2>
        <p>
          <strong>3.1. Hesap Güvenliği:</strong><br />
          Eğitim içeriğine erişim için oluşturulan hesabınızı ve erişim bilgilerinizi gizli tutmakla 
          yükümlüsünüz.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>3.2. Paylaşım Yasağı:</strong><br />
          Hesabınızı ve erişim bilgilerinizi üçüncü kişilerle paylaşamaz, devredemez veya başkalarının 
          kullanımına açamazsınız.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>3.3. Üyelik İptali:</strong><br />
          Hesabınızı veya erişim bilgilerinizi bizden izinsiz olarak başkalarıyla paylaştığınızın 
          tespit edilmesi durumunda, üyeliğiniz derhal iptal edilir.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>3.4. İptal Sonrası:</strong><br />
          Üyelik iptali durumunda, eğitim içeriğine erişiminiz sona erer ve herhangi bir iade yapılmaz.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>3.5. Tespit Yöntemleri:</strong><br />
          Hesap paylaşımının tespiti, teknik izleme, kullanım analizi veya şikayet yoluyla yapılabilir.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          4. ERİŞİM SORUNLARI
        </h2>
        <p>
          <strong>3.1. Teknik Sorunlar:</strong><br />
          Eğitim içeriğine erişimde teknik bir sorun yaşarsanız, lütfen bizimle iletişime geçiniz. 
          Sorununuz en kısa sürede çözülecektir.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>3.2. Şifre Unutma:</strong><br />
          Şifrenizi unuttuysanız, "Şifremi Unuttum" özelliğini kullanarak yeni şifre oluşturabilirsiniz.
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>3.3. Hesap Sorunları:</strong><br />
          Hesabınızla ilgili herhangi bir sorun yaşarsanız, müşteri hizmetlerimizle iletişime geçebilirsiniz.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', marginTop: '30px' }}>
          5. İLETİŞİM
        </h2>
        <p>
          Teslimat ve iade konularında sorularınız için bizimle iletişime geçebilirsiniz:
        </p>
        <p style={{ marginTop: '15px' }}>
          <strong>E-posta:</strong> info@yasasinhamileyim.com<br />
          <strong>Telefon:</strong> 0 (532) 775 76 16<br />
          <strong>Çalışma Saatleri:</strong> Pazartesi - Cuma, 09:00 - 18:00
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <p style={{ marginTop: '30px', fontWeight: 'bold', fontSize: '1.1rem', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
          <strong>ÖNEMLİ:</strong> Ürünü satın alarak ödeme işlemini tamamladığınızda, bu Teslimat 
          ve İade Koşulları'nı okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan etmiş sayılırsınız. 
          Koşullar, ödeme işleminin tamamlanması ile birlikte geçerli hale gelir.
        </p>
      </div>

      <div style={{ 
        marginTop: '40px', 
        padding: '20px', 
        backgroundColor: '#f5f7fa', 
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
          <strong>Son Güncelleme:</strong> {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </div>
    </div>
  );
};

export default TeslimatVeIade;

